import { motion } from "framer-motion";
import type { CSSProperties } from "react";
import { ChatGlass } from "../two/chat/chat-glass";
import { LandscapeDistant } from "../two/landscape/landscape-distant";
import { LandscapeForeground } from "../two/landscape/landscape-foreground";
import { LandscapeSky } from "../two/landscape/landscape-sky";
import {
	SECTION_THREE_RUNWAY_CLASS,
	SECTION_THREE_STAGE_CLASS,
	useSectionThreeScroll,
} from "./use-section-three-scroll";

/**
 * Section 3 — the pinned landscape/chat world. A runway taller than the viewport
 * carries a sticky stage; the scoped scroll hook drives the chat stream and the
 * evening parallax as S4 slides over it. On desktop the runway overlaps S2's final
 * pinned viewport, so the world slides up over the settled accordion before pinning.
 */
export function SectionThree() {
	const { runwayRef, runwayUnits, scene } = useSectionThreeScroll();

	return (
		<div
			ref={runwayRef}
			className={SECTION_THREE_RUNWAY_CLASS}
			style={{ "--section-three-runway": runwayUnits } as CSSProperties}
		>
			<div className={SECTION_THREE_STAGE_CLASS}>
				<div className="pointer-events-none absolute inset-0 z-30">
					<div className="absolute inset-0 overflow-hidden bg-grey-700 isolate">
						<LandscapeSky y={scene.skyY} eveningOpacity={scene.eveningOpacity} />
						<LandscapeDistant y={scene.distantY} eveningOpacity={scene.eveningOpacity} />
						<ChatGlass
							y={scene.chatY}
							scale={scene.chatScale}
							status={scene.chatStatus}
							intro={scene.sectionTwoIntro}
						/>
						<LandscapeForeground y={scene.foregroundY} eveningOpacity={scene.eveningOpacity} />
					</div>
				</div>
				<motion.div
					aria-hidden="true"
					className="absolute inset-0 z-40 bg-teal-700"
					style={{ opacity: scene.sectionThreeScrimOpacity }}
				/>
			</div>
		</div>
	);
}
